import { isSet } from 'rise-ui/utils/nullish.js';

export const LinesAndNodesDefaultIsSet = isSet;
export class LinesAndNodes {
  vertices;
  lines = [];
  nodes = [];
  processed = 0;

  constructor(vertices, isSet = null) {
    this.setVertices(vertices);
    this.setIsSet(isSet);
  }

  setVertices(vertices) {
    this.vertices = vertices;
  }

  setIsSet(isSet) {
    this.isSet = isSet;
  }

  processNewVertices() {
    let { processed, vertices } = this;
    if (vertices.length < processed) {
      return;
    }
    const { isSet = LinesAndNodesDefaultIsSet, lines, nodes } = this;
    let last = vertices[processed - 1];
    let lastWasSet = processed && isSet(last);
    let nextIsSet = isSet(vertices[processed]);
    // We need to check if the last vertex was added as a node,
    // but needs to be moved to a line as a result of new data.
    if (lastWasSet && nextIsSet && (processed < 2 || !isSet(vertices[processed - 2]))) {
      lines[lines.length] = [ nodes.pop() ];
    }
    for (const count = vertices.length; processed < count; ++processed) {
      nextIsSet = processed + 1 < count && isSet(vertices[processed + 1]);
      const vertex = vertices[processed];
      const isVertex = isSet(vertex);
      if (isVertex) {
        if (lastWasSet) {
          lines[lines.length - 1].push(vertex);
        } else if (lastWasSet || nextIsSet) {
          lines[lines.length] = [ vertex ];
        } else {
          nodes[nodes.length] = vertex;
        }
      }
      last = vertex;
      lastWasSet = isVertex;
    }
    this.processed = processed;
  }
}
